// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"nq-z","slideIn":"oq-z"};